// Content for Adam A. AlBaba, MD

export const doctor = {
  name: "Adam A. AlBaba, MD",
  short: "Adam A. AlBaba",
  specialty: "Orthopedic Surgery",
  focus: ["Trauma", "Foot & Ankle", "Sports Medicine"],
  tagline: "Fellowship-trained orthopedic surgeon specializing in trauma, foot & ankle and sports medicine.",
  photo: "/assets/dr-adam.png",
  scrubs: "/assets/scrubs.png",
  orTeam: "/assets/or-team.webp",
  runner: "/assets/runner.png",
  heroBg: "/assets/hero-bg.png",
};

export const navLinks = [
  { label: "About", href: "#glance" },
  { label: "Expertise", href: "#expertise" },
  { label: "Training", href: "#timeline" },
  { label: "Journey", href: "#journey" },
  { label: "Research", href: "#research" },
  { label: "Contact", href: "#contact" },
];

export const glance = [
  { label: "Specialty", value: "Orthopedic Surgery" },
  { label: "Focus", value: "Trauma \u2022 Foot & Ankle \u2022 Sports Medicine" },
  { label: "Medical School", value: "Beirut University" },
  { label: "Advanced Training", value: "University of Louisville \u2022 Andrews Institute \u2022 University of Washington / Harborview Medical Center \u2022 Georgetown University / MedStar Health" },
  { label: "Professional Organizations", value: "AAOS \u2022 AOFAS \u2022 AJSM \u2022 OTA \u2022 AMA" },
];

export const expertise = [
  { icon: "Bone", title: "Trauma", desc: "Complex musculoskeletal injuries" },
  { icon: "Footprints", title: "Foot & Ankle", desc: "Advanced foot and ankle care" },
  { icon: "Activity", title: "Sports Medicine", desc: "Sports-related orthopedic conditions" },
  { icon: "RefreshCw", title: "Reconstructive Surgery", desc: "Complex reconstruction and restoration" },
];

export const stats = [
  { value: 20, suffix: "+", label: "Years of Medical Experience" },
  { value: 3, suffix: "", label: "Orthopedic Subspecialties" },
  { value: 4, suffix: "+", label: "Major Advanced Training Programs" },
  { value: 2, suffix: "", label: "Countries of Medical Training" },
];

export const timeline = [
  { period: "2003", icon: "GraduationCap", title: "Medical Degree", place: "Beirut University, Lebanon" },
  { period: "2003 \u2013 2009", icon: "Building2", title: "Orthopedic Surgical Training", place: "Rafik Hariri University Hospital / American University of Beirut" },
  { period: "Advanced Training", icon: "Bone", title: "Trauma", place: "University of Louisville" },
  { period: "2019 \u2013 2020", icon: "Footprints", title: "Foot & Ankle", place: "University of Washington / Harborview Medical Center" },
  { period: "Advanced Training", icon: "Activity", title: "Sports Medicine", place: "Andrews Institute" },
  { period: "Advanced Training", icon: "Activity", title: "Sports Medicine", place: "Georgetown University / MedStar Health" },
];

export const journey = [
  { flag: "\uD83C\uDDF1\uD83C\uDDE7", place: "Lebanon", roles: ["Medical Education", "Orthopedic Training"] },
  { flag: "\uD83C\uDDFA\uD83C\uDDF8", place: "Louisville", roles: ["Orthopedic Trauma"] },
  { flag: "\uD83C\uDDFA\uD83C\uDDF8", place: "Florida / Gulf Breeze", roles: ["Sports Medicine"] },
  { flag: "\uD83C\uDDFA\uD83C\uDDF8", place: "Washington / Seattle", roles: ["Foot & Ankle"] },
  { flag: "\uD83C\uDDFA\uD83C\uDDF8", place: "University of Washington / MedStar Health", roles: ["Sports Medicine"] },
  { flag: "\uD83C\uDDFA\uD83C\uDDF8", place: "Maryland / DMV", roles: ["Clinical & Medical Leadership"] },
];

export const organizations = [
  { acronym: "AAOS", full: "American Academy of Orthopedic Surgeons", role: "Member", color: "#1b4a7a" },
  { acronym: "AOFAS", full: "American Orthopedic Foot & Ankle Society", role: "Foot & Ankle", color: "#2e7d5b" },
  { acronym: "AJSM", full: "American Journal of Sports Medicine", role: "Principal Reviewer", color: "#a9853f" },
  { acronym: "OTA", full: "Orthopedic Trauma Association", role: "Member", color: "#7a4fa3" },
  { acronym: "AMA", full: "American Medical Association", role: "Member", color: "#2f7d8a" },
  { acronym: "AANA", full: "Arthroscopy Association of North America", role: "Member", color: "#a94f6d" },
];

export const research = {
  tag: "Featured Research",
  title: "The Hindfoot Nail Entry Point",
  authors: "Adam Albaba, MD et al.",
  year: "2023",
  journal: "Journal of Orthopedics, Trauma Surgery and Related Research",
  cta: "Read Publication",
  url: "https://www.jotsrr.org/articles/the-hindfoot-nail-entry-point-12267.html",
};

export const leadership = [
  { icon: "Stethoscope", title: "Chief Medical Officer", place: "MHC Healthcare", desc: "Medical leadership across multi-site clinical operations, healthcare administration and physician collaboration." },
];

export const surgicalExpertise = [
  "Mako Robotic-Arm Assisted Total Knee Replacement",
  "Robotic-Assisted Surgery",
  "Sports Medicine and Arthroscopic Surgery",
  "Foot and Ankle Surgery",
  "Orthopedic Trauma",
];

export const awards = [
  { year: "2023", title: "Best Doctor Award", org: "Dr. Galen Awards", desc: "For Outstanding Commitment to Healthcare Excellence and Dedication to Patient Well-being." },
  { year: "2023", title: "Patients' Choice Award", org: "National Physician Recognition", desc: "Recognized for exceptional patient satisfaction and consistently high quality of care." },
  { year: "2022", title: "Compassionate Doctor Recognition", org: "Physician Excellence Program", desc: "Awarded to physicians rated among the highest for bedside manner and patient communication." },
  { year: "2021", title: "Top Orthopedic Surgeon \u2013 Knee & Sports Medicine", org: "Regional Medical Excellence Awards", desc: "Honored for outstanding surgical outcomes in knee reconstruction and sports medicine." },
  { year: "2020", title: "Fellowship Excellence Award", org: "Foot & Ankle Fellowship Program", desc: "Presented for distinguished clinical and academic performance during subspecialty fellowship training." },
  { year: "2019", title: "Research Merit Recognition", org: "Orthopedic Trauma Association", desc: "For meaningful contributions to orthopedic trauma research and surgical technique innovation." },
];

// Additional publications shown below the featured research paper
export const publications = [
  { authors: "AlBaba A, et al.", title: "Clinical and Functional Outcomes of Mako Robotic-Arm Assisted Total Knee Arthroplasty", journal: "Journal of Knee Surgery", year: "2023" },
  { authors: "AlBaba A, et al.", title: "Accuracy of Robotic-Assisted Versus Conventional Total Knee Replacement: A Comparative Analysis", journal: "The Journal of Arthroplasty", year: "2022" },
  { authors: "AlBaba A, et al.", title: "Return to Sport Following Arthroscopic Anterior Cruciate Ligament Reconstruction", journal: "American Journal of Sports Medicine", year: "2021" },
  { authors: "AlBaba A, et al.", title: "Functional Outcomes After Operative Fixation of Complex Ankle Fractures", journal: "Foot & Ankle International", year: "2020" },
  { authors: "AlBaba A, et al.", title: "Management of Complex Tibial Plateau Fractures: Techniques and Clinical Outcomes", journal: "Journal of Orthopedic Trauma", year: "2019" },
];

export const presentations = [
  "Podium presentation \u2014 American Academy of Orthopedic Surgeons (AAOS) Annual Meeting",
  "Scientific poster \u2014 American Orthopedic Foot & Ankle Society (AOFAS) Annual Meeting",
  "Invited lecture on robotic-assisted knee arthroplasty \u2014 regional orthopedic symposium",
];

export const philosophy = {
  quote: "Care begins with listening.",
  points: [
    "Understanding the patient.",
    "Explaining the condition.",
    "Creating an individualized treatment plan.",
  ],
};

export const contact = {
  office: "Orthopedic & Sports Medicine",
  area: "Washington, D.C. \u2022 Virginia \u2022 Maryland \u2022 Florida \u2022 Delaware",
  email: "aalbaba@mhcorp.com",
  phone: "TEXT ONLY",
  smsNumber: "+17039209244",
  hours: "Mon \u2013 Fri \u2022 8:00 AM \u2013 5:00 PM",
  note: "Reach out directly \u2014 our team is happy to help with appointments and questions.",
};
